interface IStorage {
  getItem(key: string): string | null
  setItem(key: string, value: string): void
  removeItem(key: string): void
}

const createLocalStorageWrapper = (): IStorage => {
  const getItem = (key: string): string | null => {
    try {
      return localStorage.getItem(key)
    } catch (error) {
      console.warn(`Access to localStorage is denied when getting "${key}":`, error)
      return null
    }
  }

  const setItem = (key: string, value: string): void => {
    try {
      localStorage.setItem(key, value)
    } catch (error) {
      console.warn(`Unable to set item in localStorage for key "${key}":`, error)
    }
  }

  const removeItem = (key: string): void => {
    try {
      localStorage.removeItem(key)
    } catch (error) {
      console.warn(`Unable to remove item in localStorage for key "${key}":`, error)
    }
  }

  return { getItem, setItem, removeItem }
}

/**
 * In case we want to later swap out the storage system for tests or a fallback, we can replace this
 * default instance.
 */
export const storage = createLocalStorageWrapper()

const BASE_KEY = 'chili-piper/chat'

export const getWidgetGuestIdStorageKey = (workspaceId: string, tenantId: string) => {
  return `${BASE_KEY}/chat-guest-id/${workspaceId}/${tenantId}`
}

export const getWidgetStateKey = (guestId: string) => {
  return `${BASE_KEY}/widget-state/${guestId}`
}

export const getPrepareChatDataKey = (guestId: string, workspaceId: string) => {
  return `${BASE_KEY}/prepare-chat/${workspaceId}/${guestId}`
}

export const getStoredSessionKey = (guestId: string, workspaceId: string) => {
  return `${BASE_KEY}/session/${workspaceId}/${guestId}`
}
